module.exports = __webpack_public_path__ + "static/media/plumbing-articles-blog.050353f1.jpg";